import styled from 'styled-components';

export const PackageStyled = styled.div`
  .clinicPackages {
    width: 210px !important;
    height: auto !important;
    .bottomLine {
      margin-top: 8px;
    }
    .viewDetails {
      margin-top: 10px;
    }
  }
  .packageCardWrapper {
    position: relative; 
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 202px;
    width: 100%;
    height: auto;
    border-radius: 8px;
    margin-bottom: 20px;
    border: 1px solid #e3e9ef;

    .packageCard {
      padding: 8px 7px 0px 7px;
      .badge-parent {
        width: 123px;
        height: 20px;
        position: absolute;
        top: 8px;
        left: 0px;
        z-index: 1;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }
      .imgWrapper {
        width: 100%;
        text-align: center;
        position: relative;
        padding-bottom: 8px;
        margin-bottom: 8px;

        > div {
          height: 140px;
          // margin: 20px auto 0 auto;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .share-image-parent {
        width: 25px;
        height: 25px;
        position:absolute;
        top: 14px;
        right: 22px;
        background: ${(props) => props?.theme?.color?.white};
        border: 1px solid ${(props) => props?.theme?.color?.white};
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    a {
      text-decoration: none;
    }

    .packageName {
      color: ${(props) => props?.theme?.text?.dark};
      font-size: 15px;
      font-weight: 600;
      height: 56px;
      line-height: 18px;
      margin-top: 8px;
      &.greyText {
        color: ${(props) => props?.theme?.grey?.dark};
        .highlight {
          color: ${(props) => props?.theme?.text?.dark};
        }
      }
    }
    .packageImage {
      padding: 0;
      border-radius: 3%;
      border: 1px solid #ddd;
      height: 130px;
      width: 250px;
      object-fit: fill;
    }

    .packageServices {
      font-size: 14px;
      font-weight: 700;
      line-height: 18px;
      color: ${(props) => props.theme.color.astercoreYellow};
      margin-top: 6px;
    }

    .amountBlock {
      display: flex;
      font-weight: 600;
      font-size: 15px;
      line-height: 19px;
      align-items: center;
      margin-top: 12px;
      gap:8px;

      .packageAmount {
        max-width: 110px;
        display: inline-block;
        font-size: 17px;
        font-weight: 700;
        line-height: 21px;
        color: ${(props) => props?.theme?.text?.dark};
        white-space: nowrap;
        span {
          display: block;
          width: 100%;
        }
        .actual-amount {
          margin:0;
          padding:0;
          display: inline;
          color: ${(props) => props?.theme?.text?.medium};
          text-align: right;
          font-family: 'Mulish';
          font-size: 12px;
          font-style: normal;
          font-weight: 500;
          line-height: 12px;
          text-decoration: line-through;
        }
      }
      .packageSaveAmount {
        font-weight: 500;
        font-size: 12px;
        line-height: 15px;
        color: #388E3C;
        cursor: pointer;
        white-space: nowrap;
      }
    }
    .bottomLine {
      color: ${(props) => props.theme.grey.dark};
      opacity: 5;
    }
    .viewMoreBlock {
      margin-top: 0px;
    }
    .viewDetails {
      font-weight: 700;
      font-size: 16px;
      line-height: 19px;
      text-align: center;
      color: #1976d2;
      text-decoration: capitalize;
      padding: 5;
      margin-bottom: 4px;
      cursor: pointer;
      width: 118px;
      height: 40px;
      border: 1px solid #1976d2;
      border-radius: 8px;
      vertical-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 10px;
      margin-bottom: 8px;
      white-space: nowrap;
    }
    .viewDetails a {
      color: #1976d2;
      text-decoration: none;
    }
    .amountBlock-mobile {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .packageAmount-mobile {
        max-width: 110px;
        display: inline-block;
        font-size: 17px;
        font-weight: 700;
        line-height: 21px;
        color: ${(props) => props?.theme?.text?.dark};
        white-space: nowrap;
        span {
          display: block;
          width: 100%;
        }
      }
      .packageSaveAmount-mobile {
        max-width: 150px;
        width:100%;
        font-weight: 500;
        font-size: 12px;
        line-height: 15px;
        color: #388E3C;
        cursor: pointer;
        white-space: nowrap;
      }
    }
    .share-testing-image{
      position: absolute;
      background: white;
      bottom: 90px;
      height: auto;
      width: 174px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      z-index:10;
      .box {
        height:50px;
        padding: 0px;
      }
      .box button {
        display: flex;
        align-items: center;
        div {
          padding: 0px 10px 0px 0px;
        }
      }
    }
  }

  @media (max-width: 480px) {
    .packageCardWrapper {
      width: 100%;
      height: 100%;
      max-width: 100%;
      .viewMoreBlock {
        .viewDetails {
          font-weight: 700;
          font-size: 16px;
          line-height: 19px;
          text-align: center;
          color: ${(props) => props.theme.blue.dark};
          text-decoration: capitalize;
          padding: 5;
          margin-bottom: 10px;
          cursor: pointer;
        }
      }
    }
    .share-testing-image {
      right: 30px;
    }
  }
`;
